// spotlight.service.ts
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Rectangle } from './text-control.service.interface';
@Injectable({
  providedIn: 'root',
})
export class SpotlightService {
  private spotlightSubject = new BehaviorSubject<Rectangle | null>(null);
  spotlight$ = this.spotlightSubject.asObservable();

  placeSpotlight(spotlight: Rectangle): void {
    this.spotlightSubject.next(spotlight);
  }
}
